<div class="u-shadow-mini pos-relative">
    <app-loader [showLoader]=showLoad></app-loader>

    <div class="c-portlet_box_specs sem-calls">
        <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap custom-primary">
            <div class="o-stack__cell">
                <h5 *ngIf="!hasData; else HeaderBlock">{{sectiontitle}}</h5>
                <ng-template #HeaderBlock>
                        <h5 *ngIf="callsCount>0">{{sectiontitle}}</h5>
                        <h5 *ngIf="callsCount==0">Top 5 Keywords for Phone Number Clicks</h5>
                </ng-template>
                <h4 class="calls-sub-title"> Number and Avg. Duration of Calls</h4>
                <span *ngIf="hasData && callsCount>0">
                    <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank">
                            <i class="fa fa-download" aria-hidden="true" *ngIf="!downloadConfiguration.downloadPNGIcon"></i>
                            <svg *ngIf="downloadConfiguration.downloadPNGIcon" width="14px" height="17px" viewBox="0 0 14 17">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <path d="M14,6 L10,6 L10,0 L4,0 L4,6 L0,6 L7,13 L14,6 Z M0,15 L0,17 L14,17 L14,15 L0,15 Z" class="downloadSvgIcon"  fill-rule="nonzero"></path>
                                </g>
                            </svg>
                        </a>
                </span>
            </div>
        </div>
        <div class="analytics-portlet-content top-keywords" [ngClass]="callsCount == 0 ?'p-0':''">

            <div *ngIf="!hasData" class="no-data-min-ht">
                <img [src]="placeholderimage" class="no-calls-data"/>
            </div>
            <div *ngIf="hasData">
                <div class="calls-graph-area" *ngIf="callsCount>0">
                    <div *ngIf="graphData.length > 0">
                        <div id="chart" #graphArea></div>
                    </div>
                </div>
                <div class="calls-keywords-data" [ngClass]="callsCount == 0 ?'noCalls-div':''">
                    <div class="keywords-info">
                        <div class="keywords-data" *ngIf="callsCount">
                            <div class="data">{{callsCount | number}}</div>
                            <div class="table-text"><span class="r1-text">Total Number of </span>Calls</div>
                        </div>
                        <div class="keywords-data" *ngIf="avgDuration">
                            <div class="data">{{avgDuration | number:'1.0-2'}}</div>
                            <div class="table-text">Avg. Duration <span class="r1-text">(HH:MM:SS)</span><span class="r7-text"><br/>(HH:MM:SS)</span></div>
                        </div>
                        <div class="clear"></div>
                    </div>
                    <div *ngIf="keywordsData.length > 0" class="calls-keywords-table">
                        <div class="top-keywords-text" *ngIf="callsCount>0">
                            <span class="r1-text">Top {{keywordsData.length}} Keywords for Phone Number Clicks</span>
                            <span class="r7-text">Top {{keywordsData.length}} Keywords for Calls</span>
                        </div>
                        <div class="top-keywords-table-section" [ngClass]="callsCount == 0 ?'noCalls-div':''">
                            <table class="accordion-table">
                                <thead>
                                <tr class="subtext-font add-color">
                                    <th class="top-keywords-col1"><span class="table-header_label">Keywords</span></th>
                                    <th class="top-keywords-col1">
                                        <span class="table-header_label r1-text"># Clicks</span>
                                        <span class="table-header_label r7-text" *ngIf="callsCount>0">Number of Calls</span>
                                        <span class="table-header_label r7-text" *ngIf="callsCount==0">Clicks</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngFor="let keyword of keywordsData">
                                    <td class="top-keywords-col1">{{keyword.keyword}}</td>
                                    <td class="keyword-calls">
                                        {{keyword.data | number}}{{keywordsData.length?keywordsData[0].source==='ctr'?'%':'':''}}
                                      </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
